<template>
  <div v-if="id == current" class="tab bow-form">
    <h2>{{name}}</h2>
    <slot></slot>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'TabContent',
  props: ['id', 'name', 'current'],
  components: {}
})
class TabContent extends Vue {
  @Prop id
  @Prop name
  @Prop current

  created() {
    this.$emit('createTab', this.id, this.name)
  }
}

export default TabContent
</script>

<style lang="less" scoped>
@import '../../assets/less/globals';

.bow-form {
  display: flex;
  flex-direction: column;
  width: min-content;
  min-width: 90vw;
  margin: var(--margin--small) auto;
}

h2 {
  margin-bottom: var(--margin--medium);

  text-align: center;
}
h3 {
  margin-bottom: var(--margin--small);
  margin-top: var(--margin--medium);

  text-align: center;
}

@media screen and (min-width: @screen-desktop-low) {
  .bow-form {
    min-width: 450px;
  }
}

@media screen and (min-width: @screen-desktop-large) {
  .bow-form {
    min-width: 600px;
  }
}
</style>
